import { Entity } from "@jobilla/entity";

export class HubspotCompany extends Entity {
  id!: number;
  name!: string;
  url!: string;
  isAssociated!: boolean;
}
